module.exports = __webpack_public_path__ + "officialStatic/img/pf3.a075045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/pf3.png
// module id = jwYi
// module chunks = 0